import React, { PureComponent } from 'react'

import userIcon from './assets/user-placeholder-icon.svg'

export default class MobileAvatar extends PureComponent {
  render() {
    const { src, firstName, lastName, productName } = this.props

    const imgUrl = src || userIcon

    return (
      <div className='mobile-avatar'>
        <img src={imgUrl} alt='avatar' />
        <p className='name'>
          {firstName} {lastName}
        </p>
        <p className='membership'>{`${productName}-Mitglied`}</p>
      </div>
    )
  }
}
